import React from "react";
var __jsx = React.createElement;
import stl from "./Review.module.css";
var Review = function Review(_ref) {
  var name = _ref.name,
    date = _ref.date,
    city = _ref.city,
    review = _ref.review,
    rate = _ref.rate,
    carName = _ref.carName,
    carYear = _ref.carYear,
    carCondition = _ref.carCondition;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.singleBigReviewMRP,
    id: "singleBigReviewMRP"
  }, /*#__PURE__*/React.createElement("h5", null, name), /*#__PURE__*/React.createElement("div", {
    className: stl.dateAndRatingRP
  }, /*#__PURE__*/React.createElement("div", null, carName && /*#__PURE__*/React.createElement("span", {
    className: stl.carTitle
  }, carName, " ", carYear), carCondition && /*#__PURE__*/React.createElement("span", null, carCondition), city && /*#__PURE__*/React.createElement("span", null, city))), /*#__PURE__*/React.createElement("p", null, review));
};
export default Review;